import type { HealthStatusFE } from '../system';

/**
 * REST -> domain mapping for the monitoring service's `GET /api/v1/health/status`. The input is a
 * status code rather than a wire object because the operation declares no 200 body, so no wire
 * schema is invented. `undefined` is the no-response case, which routes the `catch` through here.
 */
export const healthFromRestV1 = (status: number | undefined): HealthStatusFE => (status === 200 ? 'OK' : 'ERROR');
